<template>
  <div>
    <div v-for="(proof, proofIndex) in extractCapturedImages(grabDelivery)" :key="`proof-of-capture-${proofIndex}`">
      <h1 class="mt-4">{{ proof.label }}</h1>
      <h2 class="text-primary cursor-pointer" @click="handleProofOfImage(proof)">
        View Photo
      </h2>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  props: ["grabDelivery"],
  setup(props, { root }) {
    const getTime = (key) => {
      const [date, time] = decodeURI((key).split("_")[1].split(".")[0]).split(" ");
      return `${date} ${time.replace(/%3A/g, ":")}`;
    };

    const extractCapturedImages = (grabDelivery) => {
      const { proof_of_pickup, proof_of_delivery, proof_of_return } = grabDelivery;
      return [
        proof_of_pickup && {
          label: "Proof of Pickup",
          image: proof_of_pickup,
          timestamp: getTime(proof_of_pickup)
        },
        proof_of_delivery && {
          label: "Proof of Delivery",
          image: proof_of_delivery,
          timestamp: getTime(proof_of_delivery)
        },
        proof_of_return && {
          label: "Proof of Return",
          image: proof_of_return,
          timestamp: getTime(proof_of_return)
        },
      ].filter((item) => item);
    }

    const handleProofOfImage = (proof) => {
      root.$store.state.estoreOrders.proofOfImage = proof;
      root.$emit("bv::show::modal", "proof-of-captured-image-view");
      root.$emit("bv::hide::modal", "order-details");
    };
    return {
      extractCapturedImages,
      handleProofOfImage,
    };
  },
});
</script>
